import React from 'react';
import styled from 'styled-components';
import Section from './Section';
import SectionItem from './SectionItem';
var TextFlush = styled.p.withConfig({
  displayName: "SiteFooter__TextFlush",
  componentId: "sc-89xgq5-0"
})(["margin-bottom:0;color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.color ? theme.color : null;
});

var SiteFooter = function SiteFooter() {
  return React.createElement(Section, null, React.createElement(SectionItem, null, React.createElement(TextFlush, null, "\xA9 ", new Date().getFullYear(), " Papertrail.io. All rights reserved.")));
};

export default SiteFooter;